import { Box, Icon, Text } from '@betty/moonlight';
import { PromosBadgeListProps } from './PromosBadgeList.types';
import { memo, useMemo } from 'react';
import { rewardBadgeMap } from './PromosBadgeList.constants';
import { formatCompact } from '@betty/toolkit/utils';

function PromosBadgeList({ rewards }: PromosBadgeListProps) {
  const filteredRewards = useMemo(
    () => rewards.filter((reward) => reward.rewardAmount > 0),
    [rewards],
  );

  return (
    <Box flexDirection="row" gap="space-200">
      {filteredRewards.map((reward, i) => (
        <Box key={i}>
          {rewardBadgeMap[reward.rewardTarget] ? (
            <Box flexDirection="row" gap="space-100" alignItems="center">
              <Icon
                name={rewardBadgeMap[reward.rewardTarget]}
                gradient="accentBackground"
                width="space-500"
                height="space-500"
              />
              <Text variant="body-m-semi" color="darkSurfacePrimary">
                {formatCompact(reward.rewardAmount)}
              </Text>
            </Box>
          ) : null}
        </Box>
      ))}
    </Box>
  );
}

export default memo(PromosBadgeList);
